import React, { useState, useCallback } from 'react';
import PropTypes from 'prop-types';
import { FormattedMessage } from 'react-intl';
import { useDispatch } from 'react-redux';

import { Button } from 'ui-components/components/button';
import { Text, TextType } from 'ui-components/components/text';
import {
  NotificationService,
  NOTIFICATION_DURATIONS,
  NOTIFICATION_TYPE_ERROR,
  NOTIFICATION_TYPE_SUCCESS,
} from 'ui-components/services/notification-service';

import { MessageDescriptorPropType } from '../../prop-types/intl';
import { restoreFulfillmentsSuccess } from '../../store/orders/orders.actions';

import messages from './messages';
import style from './style.module.less';

const restoreShipmentNotification = (title, content, notificationType) => {
  NotificationService.showNotification({
    notificationType,
    title: <FormattedMessage {...title} />,
    content: <FormattedMessage {...content} />,
    duration: NOTIFICATION_DURATIONS.SHORT,
  });
};

export const RestoreButton = ({ headerTitle, onClick }) => {
  const dispatch = useDispatch();
  const [isRestoring, setIsRestoring] = useState(false);

  const onRestore = useCallback(() => {
    setIsRestoring(true);
    onClick()
      .then(() => {
        restoreShipmentNotification(
          messages.restoreShipmentSuccessTitle,
          messages.restoreShipmentSuccessMessage,
          NOTIFICATION_TYPE_SUCCESS,
        );
        dispatch(restoreFulfillmentsSuccess());
      })
      .catch(() => {
        restoreShipmentNotification(messages.restoreShipmentErrorTitle, messages.restoreShipmentErrorMessage, NOTIFICATION_TYPE_ERROR);
      });
  }, [dispatch, onClick]);

  return (
    <div className={style.wrapper}>
      <div className={style.header}>
        <Text element='h2' textType={TextType.H4} value={headerTitle} />
        <Text textType={TextType.Paragraph} value={messages.restoreHeaderMessage} />
      </div>
      <Button disabled={isRestoring} onClick={onRestore} theme='primary'>
        <FormattedMessage {...messages.restoreButton} />
      </Button>
    </div>
  );
};

RestoreButton.propTypes = {
  headerTitle: MessageDescriptorPropType.isRequired,
  onClick: PropTypes.func.isRequired,
};
